import { urbanInfraProjects } from "@/mocks/urbanInfraData";

export default function UIProjectsGrid() {
  const filtered = urbanInfraProjects;

  const getStatusStyle = (status: string) => {
    if (status === "Ongoing") return "bg-[#F36F21]/10 text-[#F36F21] border border-[#F36F21]/30";
    if (status === "Completed") return "bg-[#EAF5E1] text-[#7FBF3F] border border-[#7FBF3F]/20";
    return "bg-gray-100 text-gray-500 border border-gray-200";
  };

  const handleCardClick = (pdfUrl: string) => {
    window.open(pdfUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <section id="projects-grid" className="py-16 md:py-20 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-[#EAF5E1] text-[#7FBF3F] text-xs font-semibold px-4 py-2 rounded-full mb-4">
            <i className="ri-building-2-line"></i>All Projects
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#212121] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Our Project Portfolio
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-base">
            Explore our completed and ongoing villa plots and residential layouts on Sarjapur Road, Bengaluru.
            Click any project to view its brochure.
          </p>
        </div>



        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((project) => (
            <div
              key={project.id}
              onClick={() => handleCardClick(project.pdfUrl)}
              className="bg-white rounded-2xl overflow-hidden group hover:-translate-y-1 border border-gray-100 hover:border-[#7FBF3F]/30 transition-all duration-300 cursor-pointer"
              title={`View ${project.name} Brochure`}
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={project.image}
                  alt={`${project.name} - villa plots on Sarjapur Road Bangalore`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>

                <div className={`absolute top-3 left-3 text-xs font-semibold px-3 py-1 rounded-full ${getStatusStyle(project.status)}`}>
                  {project.status === "Ongoing" && <span className="inline-block w-1.5 h-1.5 bg-[#F36F21] rounded-full mr-1.5 animate-pulse"></span>}
                  {project.status}
                </div>
                <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm text-[#7FBF3F] text-xs font-medium px-2.5 py-1 rounded-full">
                  {project.type}
                </div>

                {/* PDF hint overlay on hover */}
                <div className="absolute inset-0 bg-[#7FBF3F]/0 group-hover:bg-[#7FBF3F]/10 transition-all duration-300 flex items-center justify-center">
                  <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-white/95 text-[#7FBF3F] text-xs font-bold px-4 py-2 rounded-full flex items-center gap-2">
                    <i className="ri-file-pdf-line text-sm"></i>
                    View Brochure
                  </div>
                </div>
              </div>

              <div className="p-5">
                <h3 className="font-bold text-[#212121] text-lg mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>{project.name}</h3>
                <div className="flex items-center gap-1.5 text-gray-500 text-xs mb-3">
                  <i className="ri-map-pin-line text-[#7FBF3F]"></i>{project.location}
                </div>
                <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-2">{project.description}</p>

                <div className="flex items-center gap-4 mb-4 text-xs text-gray-500">
                  <span className="flex items-center gap-1"><i className="ri-layout-grid-line text-[#7FBF3F]"></i>{project.area}</span>
                  <span className="flex items-center gap-1"><i className="ri-home-2-line text-[#7FBF3F]"></i>{project.units}</span>
                </div>

                <div className="bg-[#EAF5E1] rounded-lg px-3 py-2 mb-4">
                  <p className="text-[#7FBF3F] text-xs font-medium flex items-center gap-1.5">
                    <i className="ri-star-line"></i>{project.highlight}
                  </p>
                </div>

                <div className="w-full flex items-center justify-center gap-2 bg-[#7FBF3F] hover:bg-[#6aaa32] text-white text-sm font-semibold py-2.5 rounded-lg transition-colors">
                  <i className="ri-file-pdf-line"></i>
                  View Brochure
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">Interested in any of our projects? Get in touch for pricing and site visit.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://wa.me/919945124133"
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-semibold px-8 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line"></i>WhatsApp Us
            </a>
            <a
              href="tel:+919945124133"
              className="inline-flex items-center justify-center gap-2 border-2 border-[#7FBF3F] text-[#7FBF3F] hover:bg-[#EAF5E1] font-semibold px-8 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line"></i>Call Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
